import { Component } from '../../../../global/interfaces/component.interface';

export interface AtomEnergyBadgeProps {
	/* Array:
        label: Label for the Badge
        type: Icon for the selected Badge 
    */
	energyClasses: {
		label: 'A+++' | 'A++' | 'A+' | 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G';
		type?: 'water' | 'heating' | 'solar';
	}[];
}

export const MyAtomEnergyBadge: Component<AtomEnergyBadgeProps> = {
	data: {
		energyClasses: [
			{
				label: 'A+++',
				type: 'heating',
			},

			{
				label: 'B',
				type: 'water',
			},

			{
				label: 'C',
				type: 'solar',
			},

			{
				label: 'G',
			},
		],
	},
};
// a-energy-badge
export default MyAtomEnergyBadge;
